import React from 'react'
import { FormattedMessage } from 'react-intl'
import { formatPrice } from 'utils/common'
import {
	RefundTotalBody,
	RefundTotalRow,
	RefundTotalTitle,
	RefundTotalWrapper,
	RefundTotalRowKey,
	RefundTotalRowPrice,
} from './style'
import { toNumber } from 'lodash'
import AnimatedNumber from 'react-animated-number'
import config from '../../configs/config'

const RefundTotal = ({ totals = {}, mode = '', currency = '', ...props }) => {
	const { returnTotal } = totals
	/**
	 * isNeedToShow {Function}
	 * @param {Number}
	 * @description - define do we need to show value
	 * @return {Boolean}
	 *
	 * */
	const isNeedToShow = (value, isMoreThanZero = false) => {
		return isMoreThanZero
			? !!value !== undefined && toNumber(value) > 0
			: !!value !== undefined
	}

	return (
		<RefundTotalWrapper {...props}>
			<RefundTotalTitle>
				<FormattedMessage
					id='cart.expanded.title'
					defaultMessage='Summary'
				/>
			</RefundTotalTitle>
			<RefundTotalBody mode={mode}>
				{isNeedToShow(returnTotal) && (
					<RefundTotalRow>
						<RefundTotalRowKey>
							<FormattedMessage
								id='cart.expanded.returned.total.cost'
								defaultMessage='Return Value'
							/>
						</RefundTotalRowKey>
						<RefundTotalRowPrice>
							<AnimatedNumber
								value={returnTotal}
								duration={
									config.numbersAnimation
										.numberAnimationDuration
								}
								stepPrecision={
									config.numbersAnimation.numberStepPrecision
								}
								formatValue={(n) => {
									return formatPrice(n, currency)
								}}
							/>
						</RefundTotalRowPrice>
					</RefundTotalRow>
				)}
			</RefundTotalBody>
		</RefundTotalWrapper>
	)
}
export default RefundTotal
